import { action, observable } from 'mobx';
import axios from 'axios';
import { isBoolean } from '~/common/utils/typeCheckers';

class SharedFormUtilsClass {
    @observable displayOptIn = false;
    @observable emailAlreadyUsedError = false;
    @observable isLoading = false;

    @action setIsLoading(bool) {
        this.isLoading = isBoolean(bool, this.isLoading);
    }

    @action setDisplayOptIn(bool) {
        if (typeof bool === 'boolean') {
            this.displayOptIn = bool;
        }
    }

    @action setEmailAlreadyUsedError(bool) {
        if (typeof bool === 'boolean') {
            this.emailAlreadyUsedError = bool;
        }
    }

    // validate Email
    @action validateEmail(email, successCallback) {
        // clear previus error
        this.setEmailAlreadyUsedError(false);
        // verify email
        this.setIsLoading(true);
        axios.get(`/api/User?username=${email}`)
            .then((response) => {
                this.setIsLoading(false);
                if (!response.data) throw new Error('no response data');
                // call success function
                successCallback(response.data);
            }).catch((err) => {
                this.setIsLoading(false);
                return err;
            });
    }
}

const sharedFormUtilsStore = new SharedFormUtilsClass();
export { sharedFormUtilsStore, SharedFormUtilsClass };
